import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

export interface CuttingData {
  id?: number;
  refreshToken?: string;
  orderName: string;
  cloudOrderId: number;
  client: CuttingClientData;
}

interface CuttingClientData {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
}

@Injectable()
export class CuttingService {
  constructor(private router: Router) {}

  encodeLink(link: CuttingData) {
    let str = JSON.stringify(link);
    return btoa(str.slice(1, str.length - 1));
  }

  decodeLink(base64url: string) {
    try {
      // Преобразуем base64url → стандартный base64
      let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");

      // Добавляем padding (до кратности 4)
      while (base64.length % 4 !== 0) {
        base64 += "=";
      }

      // Декодируем из base64 → бинарная строка
      const binaryString = atob(base64);

      // Преобразуем бинарную строку в Uint8Array
      const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
      let json = new TextDecoder().decode(bytes);

      if (!json.startsWith("{")) {
        json = "{" + json + "}";
      }

      return JSON.parse(json) as CuttingData;
    } catch {
      return undefined;
    }
  }

  goToProject(id: number) {
    this.router.navigate([`/project/${id}`]);
  }
}
